import styled from 'styled-components'

export const Container = styled.div`
  max-height: 600px;
  overflow-y: auto;
`
